<!--suppress 
    BSelect,
    BButton,
ALL -->
<template>
  <LoadingSkeleton v-if="isLoading" :loading-text="$t('loading-in-progress')" />
  <div v-else-if="isExistingGraeProjects">
    <div class="year-navigation">
      <b-button
        class="button is-primary"
        :disabled="selectedAnneeScolaire === anneesScolaires[anneesScolaires.length - 1]"
        outlined
        @click="previousYear"
      >
        {{ $t("graePage.details.projets.precedent") }}
      </b-button>
      <b-select v-model="selectedAnneeScolaire" @update:model-value="goToYear">
        <template v-for="option in anneesScolaires" :key="option">
          <option :value="option">
            {{ option }}
          </option>
        </template>
      </b-select>
      <b-button
        :disabled="selectedAnneeScolaire === anneesScolaires[0]"
        class="button is-primary"
        outlined
        @click="nextYear"
      >
        {{ $t("graePage.details.projets.suivant") }}
      </b-button>
    </div>
    <div class="indicateurs-container">
      <div class="indicateurs-column">
        <div class="indicateurs-block bordered main-indicateur">
          <div class="svg-item">
            <svg width="100%" height="100%" viewBox="0 0 40 40" class="donut">
              <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#fff"></circle>
              <circle
                class="donut-ring"
                cx="20"
                cy="20"
                r="15.91549430918954"
                fill="transparent"
                stroke-width="3.5"
              ></circle>
              <circle
                class="donut-segment donut-segment-2"
                cx="20"
                cy="20"
                r="15.91549430918954"
                fill="transparent"
                stroke-width="3.5"
                :stroke-dasharray="dasharray"
                stroke-dashoffset="25"
              ></circle>
              <g class="donut-text donut-text-1">
                <text y="50%" transform="translate(0, 2)">
                  <tspan x="50%" text-anchor="middle" class="donut-percent">
                    {{
                      Number.isNaN(graeStats.nbATE + graeStats.nbAME)
                        ? " "
                        : graeStats.nbATE + graeStats.nbAME
                    }}
                  </tspan>
                </text>
                <text y="60%" transform="translate(0, 2)">
                  <tspan x="50%" text-anchor="middle" class="donut-data">
                    {{ $t("IndicateursPage.projets-actifs") }}
                  </tspan>
                </text>
              </g>
            </svg>
          </div>

          <div class="column">
            <div class="line">
              <span class="ate rounded">{{ graeStats.nbATE }}</span>
              <img class="logo" src="/img/scarabee.svg" alt="Scarabée" />
              <span>{{ $t("IndicateursPage.ate-actives") }}</span>
            </div>
            <div v-if="!EXCLUDED_REGIONS.includes(grae.region)" class="line">
              <span class="ame rounded">{{ graeStats.nbAME }}</span>
              <img class="logo" src="/img/poisson.svg" alt="Poisson" />
              <span>{{ $t("IndicateursPage.ame-actives") }}</span>
            </div>
          </div>
        </div>
        <div class="indicateurs-block">
          <div class="indicateurs-card bordered">
            <router-link
              :to="{
                path: `/grae/details/0/${grae.id}`,
                query: {
                  filters: INSCRIPTION_FILTERS,
                },
              }"
            >
              <div class="title violet">
                {{ $t("IndicateursPage.inscription") }}<br />({{
                  graeStats.anneeScolaireInscription
                }})
              </div>
              <div class="indicateur">{{ graeStats.inscriptions }}</div>
              <div class="text-bold">{{ $t("IndicateursPage.nouveaux-inscrits") }}</div>
            </router-link>
          </div>
          <div class="indicateurs-card bordered">
            <router-link
              :to="{
                path: `/grae/details/0/${grae.id}`,
                query: {
                  filters: labellisesFilters,
                },
              }"
            >
              <div class="title orange">
                {{ $t("IndicateursPage.labellisation") }}<br />({{ graeStats.anneeScolaire }})
              </div>
              <div class="indicateur">{{ graeStats.labellisationsAccepteesCloturees }}</div>
              <div class="text-bold">{{ $t("IndicateursPage.labellises") }}</div>
            </router-link>
          </div>
          <div class="indicateurs-card bordered">
            <router-link
              :to="{
                path: `/grae/details/0/${grae.id}`,
                query: {
                  filters: renouvellesFilters,
                },
              }"
            >
              <div class="title orange">
                {{ $t("IndicateursPage.renouvellement") }}<br />({{ graeStats.anneeScolaire }})
              </div>
              <div class="indicateur">{{ graeStats.renouvellementsAcceptesClotures }}</div>
              <div class="text-bold">{{ $t("IndicateursPage.renouvelles") }}</div>
            </router-link>
          </div>
          <div class="indicateurs-card bordered">
            <router-link
              :to="{
                path: `/grae/details/0/${grae.id}`,
                query: {
                  filters: refusesFilters,
                },
              }"
            >
              <div class="title marron">
                {{ $t("IndicateursPage.refus") }}<br />({{ graeStats.anneeScolaire }})
              </div>
              <div class="indicateur">{{ graeStats.projetsRefuses }}</div>
              <div class="text-bold">{{ $t("IndicateursPage.refuses") }}</div>
            </router-link>
          </div>
        </div>
        <div v-if="selectedAnneeScolaire === anneesScolaires[0]" class="indicateurs-block">
          <div>
            <router-link
              :to="{
                path: `/grae/details/0/${grae.id}`,
                query: {
                  filters: EN_PAUSE_FILTERS,
                },
              }"
              class="bordered centered indicateur-text"
            >
              <span>{{ graeStats.pause }} {{ $t("IndicateursPage.pauses") }}</span>
            </router-link>
          </div>
          <div>
            <router-link
              :to="{
                path: `/grae/details/0/${grae.id}`,
                query: {
                  filters: ARRETES_FILTERS,
                },
              }"
              class="bordered centered indicateur-text"
            >
              <span>{{ graeStats.arrete }} {{ $t("IndicateursPage.arretes") }}</span>
            </router-link>
          </div>
        </div>
      </div>
      <div v-if="selectedAnneeScolaire === anneesScolaires[0]" class="indicateurs-column">
        <div class="indicateurs-column bordered">
          <h2>{{ $t("IndicateursPage.phase-inscription") }}</h2>
          <div class="indicateurs-block">
            <router-link
              :to="{
                path: `/instruction/inscriptions/0/0/${grae.id}`,
              }"
              class="indicateurs-card bordered"
            >
              <div class="title violet">{{ $t("IndicateursPage.a-instruire") }}</div>
              <div class="indicateur">{{ graeStats.inscriptionsNonInstruites }}</div>
              <div class="text">{{ $t("IndicateursPage.deposes-a-instruire") }}</div>
            </router-link>
            <router-link
              :to="{
                path: `/grae/details/0/${grae.id}`,
                query: {
                  filters: BROUILLON_FILTERS,
                },
              }"
              class="indicateurs-card bordered"
            >
              <div class="title violet-pale">{{ $t("IndicateursPage.brouillon") }}</div>
              <div class="indicateur">{{ graeStats.inscriptionsBrouillon }}</div>
              <div class="text">{{ $t("IndicateursPage.dossiers-brouillon") }}</div>
            </router-link>
          </div>
        </div>
        <div class="indicateurs-column bordered">
          <h2>{{ $t("IndicateursPage.phase-labellisation") }}</h2>
          <div class="indicateurs-block">
            <router-link
              :to="{
                path: `/instruction/labellisations/1/2/${grae.id}`,
              }"
              class="indicateurs-card bordered"
            >
              <div class="title marron">{{ $t("IndicateursPage.instruits") }}</div>
              <div class="indicateur">{{ graeStats.labellisationsInstructionTerminee }}</div>
              <div class="text">{{ $t("IndicateursPage.deposes-instruits") }}</div>
            </router-link>
            <router-link
              :to="{
                path: `/instruction/labellisations/0/0/${grae.id}`,
              }"
              class="indicateurs-card bordered"
            >
              <div class="title orange">{{ $t("IndicateursPage.a-instruire") }}</div>
              <div class="indicateur">{{ graeStats.labellisationsAttenteInstructeur }}</div>
              <div class="text">{{ $t("IndicateursPage.deposes-a-instruire") }}</div>
            </router-link>
          </div>
        </div>
        <div class="indicateurs-column bordered">
          <ContactCardsView :contact="contact" />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <p>{{ $t("IndicateursPage.aucun-projet") }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"

import { GraeDTO, GraeStatsDTO, UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { Filters } from "@/model/bean/Filters"
import { StatService } from "@/services/rest/stats/StatService"
import { GraeService } from "@/services/rest/grae/GraeService"
import { UsersService } from "@/services/rest/users/UsersService"
import { InfoReportingService } from "@/services/log/InfoReportingService"
import ContactCardsView from "@/views/commons/ContactCardsView.vue"
import LoadingSkeleton from "@/views/generic_components/LoadingSkeleton.vue"
import { BButton, BSelect } from "buefy"

export const EXCLUDED_REGIONS = [
  "Grand Est",
  "Île-de-France",
  "Bourgogne-Franche-Comté",
  "Centre-Val de Loire",
  "Auvergne-Rhône-Alpes",
]
export const BROUILLON_FILTERS = JSON.stringify(
  Filters.asFilters([
    { property: "typeDossier", values: ["DOSSIER_INSCRIPTION"] },
    { property: "statut", values: ["BROUILLON"] },
  ]),
)
export const INSCRIPTION_FILTERS = JSON.stringify(
  Filters.asFilters([
    { property: "inscriptionThisYear", values: ["true"] },
    { property: "projet.etat", values: ["ACTIF", "EN_COURS_DE_CREATION"] },
  ]),
)

export const EN_PAUSE_FILTERS = JSON.stringify(
  Filters.asFilters([
    {
      property: "projet.etat",
      values: ["EN_PAUSE"],
    },
  ]),
)

export const ARRETES_FILTERS = JSON.stringify(
  Filters.asFilters([
    {
      property: "typeDossier",
      values: ["DOSSIER_LABELLISATION", "DOSSIER_RENOUVELLEMENT_LIGHT", "DOSSIER_RENOUVELLEMENT"],
    },
    {
      property: "projet.etat",
      values: ["ARCHIVE"],
    },
  ]),
)

export const LABELLISES_BASE_FILTERS = [
  { property: "typeDossier", values: ["DOSSIER_LABELLISATION"] },
  { property: "statut", values: ["ACCEPTE", "LABELLISATION_EN_DEVENIR"] },
]

export const RENOUVELLES_BASE_FILTERS = [
  {
    property: "typeDossier",
    values: ["DOSSIER_RENOUVELLEMENT", "DOSSIER_RENOUVELLEMENT_LIGHT"],
  },
  { property: "statut", values: ["ACCEPTE"] },
]

export const REFUSES_BASE_FILTERS = [
  {
    property: "typeDossier",
    values: ["DOSSIER_LABELLISATION", "DOSSIER_RENOUVELLEMENT", "DOSSIER_RENOUVELLEMENT_LIGHT"],
  },
  { property: "statut", values: ["REFUSE"] },
]

export default defineComponent({
  name: "IndicateursView",
  components: {
    ContactCardsView,
    LoadingSkeleton,
    BButton,
    BSelect,
  },
  props: {
    grae: {
      type: Object as PropType<GraeDTO>,
      required: true,
    },
  },
  data() {
    return {
      // Ajout des constantes dans data
      EXCLUDED_REGIONS,
      BROUILLON_FILTERS,
      INSCRIPTION_FILTERS,
      EN_PAUSE_FILTERS,
      ARRETES_FILTERS,
      LABELLISES_BASE_FILTERS,
      RENOUVELLES_BASE_FILTERS,
      REFUSES_BASE_FILTERS,

      statsService: StatService.INSTANCE,
      graeService: GraeService.INSTANCE,
      usersService: UsersService.INSTANCE,
      infoReportingService: InfoReportingService.INSTANCE,

      isLoading: true,
      isExistingGraeProjects: false,
      graeStats: new GraeStatsDTO(),
      contact: new UtilisateurDTO(),
      dasharray: "100 0",
      anneesScolaires: [] as Array<string>,
      selectedAnneeScolaire: "",
    }
  },
  computed: {
    labellisesFilters(): string {
      return this.addAnneeScolaireToFilters(LABELLISES_BASE_FILTERS)
    },

    renouvellesFilters(): string {
      return this.addAnneeScolaireToFilters(RENOUVELLES_BASE_FILTERS)
    },

    refusesFilters(): string {
      return this.addAnneeScolaireToFilters(REFUSES_BASE_FILTERS)
    },
  },
  watch: {
    grae: {
      async handler() {
        if (this.grae && this.grae.id) {
          this.anneesScolaires = await this.graeService.getAnneesScolairesForGRAE(this.grae.id)
        } else {
          this.anneesScolaires = await this.graeService.getAnneesScolaires()
        }

        this.goToYear(this.anneesScolaires[0])
      },
      immediate: false,
    },
  },
  mounted() {
    this.loadAnneesScolaires()
  },
  methods: {
    addAnneeScolaireToFilters(baseFilters: any[]): string {
      const filtersWithYear = [
        ...baseFilters,
        { property: "anneeScolaire", values: [this.graeStats.anneeScolaire] },
      ]
      return JSON.stringify(Filters.asFilters(filtersWithYear))
    },

    async getStatsForGrae(): Promise<void> {
      if (this.grae && this.grae.id) {
        this.isLoading = true
        try {
          if (this.selectedAnneeScolaire === this.anneesScolaires[0]) {
            this.graeStats = await this.statsService.graeStats(this.grae.id)
          } else {
            this.graeStats = await this.statsService.graeStatsForAnnee(
              this.grae.id,
              this.selectedAnneeScolaire,
            )
          }
          this.isExistingGraeProjects = this.graeStats != undefined

          if (this.grae.contactId) {
            try {
              this.contact = await this.usersService.getUserProfile(this.grae.contactId)
            } catch (e: any) {
              this.infoReportingService.error("Erreur rencontrée sur le contact", e as Error)
            }
          } else {
            this.contact.courriel = this.$t("default.email").toString()
            this.contact.telephone = this.$t("default.phone").toString()
            this.contact.nom = this.$t("default.profil").toString()
          }
          this.refreshDonutChart()
        } finally {
          this.isLoading = false
        }
      }
    },

    refreshDonutChart(): void {
      const amePercent =
        (100 * this.graeStats.nbATE) / (this.graeStats.nbATE + this.graeStats.nbAME)
      this.dasharray = amePercent + " " + (100 - amePercent)
    },

    previousYear(): void {
      const thisYearIndex = this.anneesScolaires.indexOf(this.selectedAnneeScolaire)
      this.$nextTick(() => {
        this.selectedAnneeScolaire = this.anneesScolaires[thisYearIndex + 1]
        this.getStatsForGrae()
      })
    },

    nextYear(): void {
      const thisYearIndex = this.anneesScolaires.indexOf(this.selectedAnneeScolaire)
      this.$nextTick(() => {
        this.selectedAnneeScolaire = this.anneesScolaires[thisYearIndex - 1]
        this.getStatsForGrae()
      })
    },

    goToYear(newValue: string): void {
      this.selectedAnneeScolaire = newValue
      this.$nextTick(() => {
        this.getStatsForGrae()
      })
    },

    async loadAnneesScolaires(): Promise<void> {
      if (this.grae && this.grae.id) {
        this.anneesScolaires = await this.graeService.getAnneesScolairesForGRAE(this.grae.id)
      } else {
        this.anneesScolaires = await this.graeService.getAnneesScolaires()
      }

      this.goToYear(this.anneesScolaires[0])
    },
  },
})
</script>

<style lang="scss">
.indicateurs-container {
  display: flex;
  flex-direction: row;
  align-content: stretch;
  flex-wrap: wrap;

  .indicateurs-column {
    display: flex;
    flex-direction: column;
    padding: 10px;
    min-width: 230px;
    width: 50%;

    .indicateurs-block {
      display: flex;
      flex-direction: row;
      align-content: stretch;
      flex-wrap: wrap;
      justify-content: center;

      > div {
        flex-grow: 1;
      }

      a {
        color: $text-default-color;

        &:hover {
          color: $primary;
        }
      }
    }
  }
}

.bordered {
  border: 1px solid $bookmarkcard-border-color;
  border-radius: 10px;
  margin: 5px;
  text-align: center;
  padding: 10px;
  min-height: 70px;

  font-family: $font-family;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;

  &.indicateurs-column {
    width: 100%;
  }

  &.centered {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > h2 {
    text-transform: uppercase;
    font-family: $font-family-title;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 120%;
  }
}

.indicateurs-card {
  text-align: center;
  max-width: 300px;

  .title {
    font-family: $font-family;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;

    color: $text-light-color;

    height: 30px;
    margin-top: -10px;
    margin-bottom: 5px !important;
    border-radius: 0 0 10px 10px;
    min-width: 102px;
    max-width: 125px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;

    &.violet {
      background: $indicateurs-inscription-a-instruire;
    }

    &.violet-pale {
      background: $indicateurs-inscription-brouillon;
    }

    &.bleu {
      background: $ofb-bleu-1;
    }

    &.marron {
      background: $indicateurs-labellisation-instuit;
    }

    &.orange {
      background: $indicateurs-labellisation-a-instruire;
    }
  }

  .indicateur {
    font-family: $font-family;
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
    line-height: 60px;
  }

  .text {
    font-family: $font-family;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
  }

  .text-bold {
    font-family: $font-family;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 23px;
  }
}

.main-indicateur {
  .column {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .line {
      display: flex;
      align-items: center;

      .rounded {
        color: $text-light-color;
        border-radius: 25px;
        height: 50px;
        width: 50px;
        display: flex;
        margin: 10px;
        align-items: center;
        justify-content: center;

        font-family: $font-family;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 30px;

        &.ate {
          background: $indicateurs-ate;
        }

        &.ame {
          background: $indicateurs-ame;
        }
      }

      .logo {
        height: 50px;
        width: 50px;
        margin-right: 10px;
      }
    }
  }
}

.svg-item {
  width: 100%;
  font-size: 16px;
  margin: 0 auto;
}

@media (min-width: 992px) {
  .svg-item {
    width: 80%;
  }
}

.donut-ring {
  stroke: $indicateurs-ame;
}

.donut-segment-2 {
  stroke: $indicateurs-ate;
}

.donut-label {
  font-size: 0.28em;
  font-weight: 700;
  line-height: 1;
  fill: $text-default-color;
  transform: translateY(0.25em);
}

.donut-percent {
  font-family: $font-family;
  font-style: normal;
  font-weight: 700;
  font-size: 8px;
  line-height: 10px;
  transform: translateY(0.5em);
  fill: $text-default-color;
}

.donut-data {
  font-family: $font-family;
  font-style: normal;
  font-weight: 700;
  font-size: 3px;
  line-height: 10px;
  transform: translateY(0.5em);
  fill: $text-default-color;
}

.svg-item {
  max-width: 40%;
  display: inline-block;
}

$card-width: 450px;
$card-height: 120px;
.custom-card {
  width: $card-width;
  height: $card-height;
  border-radius: 10px;
  border: 1px solid $bookmarkcard-border-color;
}

.custom-card-content {
  margin: 0.5rem;
}

.contact-card {
  width: max-content;
}
</style>
